import { useRef } from 'react'

import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'
import { timeZone } from '@constants/timeZone'
import { useOnClickOutside } from '@hooks/use-click-outside'
import IconMeet from '@public/images/icon-popup-meetup/access-time.svg'
import DateRange from '@public/images/icon-popup-meetup/date-range.svg'
import EmailIcon from '@public/images/icon-popup-meetup/email.svg'
import TimeStampIcon from '@public/images/icon-popup-meetup/time-stamp.svg'

import {
  Popup,
  Wrap,
  WrapStep,
  ContWrapDiv,
  TitleMeetup,
  SubTitleMeetup,
  InfoMeetup,
  ContWrapMeetup,
  ButtonSubmit,
  PopupWrapper,
  CloseBtn,
} from './styles'

export function PopupThird({ handleClose }) {
  const infoUser = JSON.parse(sessionStorage.getItem('data'))
  const dateUser = new Date(sessionStorage.getItem('userDuration'))

  const timeZoneKey = sessionStorage.getItem('timeZone')
  const timeZoneOffset = timeZone[timeZoneKey]
  const offsetString = ` (GMT${timeZoneOffset})`

  const bookCallWrapperRef = useRef()
  useOnClickOutside(bookCallWrapperRef, handleClose, true)

  return (
    <PopupWrapper>
      <Popup ref={bookCallWrapperRef}>
        <WrapStep>
          <ContWrapDiv>step 03/03</ContWrapDiv>
          <CloseBtn onClick={handleClose}>Close</CloseBtn>
        </WrapStep>
        <Wrap>
          <TitleMeetup>Our meetup has been successfully scheduled.</TitleMeetup>
          <SubTitleMeetup>
            Thank you for your trust! We have sent a confirmation letter to your
            email box. Looking forward to meeting you.
          </SubTitleMeetup>
          <InfoMeetup>
            <ContWrapMeetup>
              <DateRange />
              {dateUser.toLocaleString('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour12: false,
              })}
            </ContWrapMeetup>
            <ContWrapMeetup>
              <IconMeet />
              {dateUser.toLocaleString('en-US', {
                hour12: false,
                hour: ['numeric'],
                minute: ['numeric'],
              })}
              {offsetString}
            </ContWrapMeetup>
            <ContWrapMeetup>
              <TimeStampIcon />
              {sessionStorage.getItem('timeZone')}
              {offsetString}
            </ContWrapMeetup>
            <ContWrapMeetup>
              <EmailIcon />
              {infoUser.email}
            </ContWrapMeetup>
          </InfoMeetup>
          <ContWrapDiv>
            <ButtonSubmit className="return-btn" onClick={handleClose}>
              Return to website
            </ButtonSubmit>
          </ContWrapDiv>
        </Wrap>
        <ImageWithPlaceholder
          width="170"
          height="170"
          alt="Full orange hexagon"
          src="/images/full-empty-orange-hexagon.webp"
        />
      </Popup>
    </PopupWrapper>
  )
}
